import Vue from 'vue';

const vueInstance = new Vue();
const h = vueInstance.$createElement;

export default {
  fireSuccess(message, duration = 3000) {
    vueInstance.$notify({
      type: 'success',
      title: 'Success',
      message: h('div', message),
      duration,
    });
  },
  fireError(message, duration = 3000) {
    vueInstance.$notify({
      type: 'error',
      title: 'Error',
      message: h('div', { style: 'color: red' }, message),
      duration,
    });
  },
};
